'use client';

import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { clsx } from 'clsx';
import { useBuilderStore } from '@/store/builderStore';

const steps = [
  { id: 1, label: 'Describe' },
  { id: 2, label: 'Material' },
  { id: 3, label: 'Upload' },
  { id: 4, label: 'AI Preview' },
  { id: 5, label: 'Review' },
];

export default function Stepper() {
  const { currentStep } = useBuilderStore();

  return (
    <div className="flex items-center w-full lg:hidden mb-6">
      {steps.map((step, idx) => {
        const isCompleted = currentStep > step.id;
        const isActive = currentStep === step.id;

        return (
          <div key={step.id} className="flex items-center flex-1 last:flex-none">
            <div className="flex flex-col items-center gap-1">
              <div
                className={clsx(
                  'w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold transition-all duration-300',
                  {
                    'bg-gradient-to-br from-amber-400 to-amber-600 text-white shadow-md': isActive,
                    'bg-emerald-500 text-white': isCompleted,
                    'bg-slate-100 text-slate-400 border border-slate-200': !isActive && !isCompleted,
                  }
                )}
              >
                {isCompleted ? <Check size={12} strokeWidth={3} /> : step.id}
              </div>
              <span
                className={clsx('text-[10px] font-medium hidden sm:block', {
                  'text-amber-600': isActive,
                  'text-emerald-600': isCompleted,
                  'text-slate-400': !isActive && !isCompleted,
                })}
              >
                {step.label}
              </span>
            </div>
            {idx < steps.length - 1 && (
              <motion.div
                className={clsx('flex-1 h-0.5 mx-1 transition-colors duration-500', {
                  'bg-emerald-400': isCompleted,
                  'bg-slate-200': !isCompleted,
                })}
                animate={{
                  backgroundColor: isCompleted ? '#4ade80' : '#e2e8f0',
                }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
